module.exports = __webpack_public_path__ + "static/media/9-consent-workshop2.d20fe6b4.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/pdf/9-consent-workshop2.pdf
// module id = 162
// module chunks = 0